import React, { Component } from "react"

import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"

import { Segment, Grid } from "semantic-ui-react"
import Clients from "./Clients"
import BandeauNoir from "../Entete/BandeauNoir"

import RechercheFiltre from "../Entete/RechercheFiltre"
import ModalClients from "./ModalClients"
import { person as clientIcon } from "react-icons-kit/ionicons/person"
import "./ClientsComponent.css"
import clientService from "./ClientService"
import ClientService from "./ClientService"

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedClientComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchValue: "",
      clientsData: [
        {
          type: "user",
          name: "Alvin",
          firstName: "Peter",
          adress: "6 rue d'Alexandrie, 75002 Paris, France",
          email: "maxime_guttmann@gmail.com",
          phone: "617-466-0172",
          id: 1
        },
        {
          type: "user",
          name: "Kenneth",
          firstName: "Buchanan",
          adress: "7994 Alexis Union Suite 570",
          email: "catalina_emard@hotmail.com",
          phone: "016-982-0383",
          id: 2
        },
        {
          type: "user",
          name: "Jorge",
          firstName: "Pope",
          adress: "6 rue d'Alexandrie, 75002 Paris, France",
          email: "maxime_guttmann@gmail.com",
          phone: "617-466-0172",
          id: 3
        },
        {
          type: "user",
          name: "Leroy",
          firstName: "Goodman",
          adress: "6 rue d'Alexandrie, 75002 Paris, France",
          email: "alvis.lueilwitz@yahoo.com",
          phone: "326-375-1649",
          id: 4
        },
        {
          type: "user",
          name: "Gussi",
          firstName: "Rowe",
          adress: "6 rue d'Alexandrie, 75002 Paris, France",
          email: "hodkiewicz_xavier@jaiden.tv",
          phone: "308-778-4197",
          id: 5
        }
      ]
    }

    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleSave = this.handleSave.bind(this)
  }

  componentWillMount() {}

  handleSearchChange(e, data) {
    var searchValue = data.value
    this.setState({
      searchValue
    })
  }

  handleEditClient = row => {
    console.log("edit cli", row)
    var tabCopy = ClientService.edit(this.state.clientsData, row)
    this.setState({
      clientsData: tabCopy
    })
  }

  handleSave(clientData) {
    var tabCopy = this.state.clientsData
    tabCopy.push({
      ...clientData,
      type: clientData.toggle ? "user" : "group"
    })
    this.setState({
      clientsData: tabCopy
    })
  }

  render() {
    console.log("state Client", this.state)
    let { t } = this.props
    var clientRows = clientService.buildClientRows(
      this.state.clientsData,
      this.state.searchValue
    )
    return (
      <Segment id="main" mobile={16} tablet={8} computer={4}>
        <BandeauNoir category={t("title_bandeau_client")} icon={clientIcon}>
          <ModalClients onSave={data => this.handleSave(data)} />
        </BandeauNoir>
        <RechercheFiltre
          prestations={t("placeholder_search_chercher_client")}
          style={{ padding: "20px 0", margin: "0 18px" }}
          onSearchChange={this.handleSearchChange}
        />
        {clientRows.map(
          client =>
            client.first || client.second ? (
              <Grid className="clientRow" columns={2}>
                {client.first ? (
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Clients edit={this.handleEditClient} {...client.first} />
                  </Grid.Column>
                ) : null}
                {client.second ? (
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Clients edit={this.handleEditClient} {...client.second} />
                  </Grid.Column>
                ) : null}
              </Grid>
            ) : null
        )}
      </Segment>
    )
  }
}

const ClientComponent = connect(mapStateToProps)(ConnectedClientComponent)
export default translate("ClientComponent")(ClientComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/Clients/ClientsComponent.jsx